<template>
  <div class="section-content section3">
    <div class="content-wrapper">
      <div class="glasses-display" :class="{'animate__show': isActive}">
        <img src="../assets/glasses3.png" alt="Translation Glasses">
      </div>
      <div class="text-content" :class="{'animate__show': isActive}">
        <h3>同传翻译，与世界对话</h3>
        <p class="description">语言障碍已不再是问题，快速准确翻译</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Section3',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.section-content {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #000;
  color: #fff;
  padding: 0;
  overflow: hidden;
}

.content-wrapper {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8%;
  gap: 3%;
}

.text-content {
  flex: 1;
  text-align: left;
  opacity: 0;
  transform: translateX(30px);
  transition: all 0.8s ease;
}

.text-content.animate__show {
  opacity: 1;
  transform: translateX(0);
}

h3 {
  font-size: 40px;
  margin-bottom: 30px;
  position: relative;
  display: inline-block;
}

h3::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #42b983;
}

.description {
  font-size: 20px;
  color: rgba(255,255,255,0.7);
  line-height: 1.6;
}

.glasses-display {
  flex: 2.0;
  position: relative;
  display: flex;
  justify-content: center;
  opacity: 0;
  transform: translateX(-30px);
  transition: all 0.8s ease;
}

.glasses-display.animate__show {
  opacity: 1;
  transform: translateX(0);
}

.glasses-display img {
  width: 100%;
  height: auto;
  filter: drop-shadow(0 0 20px rgba(66,185,131,0.2));
}

.languages-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  width: 60%;
}

.language {
  color: #42b983;
  font-size: 1.1rem;
  padding: 5px 15px;
  background: transparent;
  text-shadow: 0 0 10px rgba(66,185,131,0.5);
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.animate__animated {
  opacity: 0;
}

.animate__show {
  opacity: 1;
}

@media screen and (max-width: 768px) {
  .section-content {
    height: auto;
  }

  .content-wrapper {
    flex-direction: column-reverse;
    padding: 60px 32px;
    gap: 40px;
  }

  .text-content {
    text-align: center;
    transform: translateX(0);
  }

  h3 {
    font-size: 36px;
    margin-bottom: 24px;
  }

  h3::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .description {
    font-size: 24px;
    text-align: center;
  }

  .glasses-display {
    width: 100%;
    transform: translateX(0);
  }

  .glasses-display img {
    width: 100%;
    margin: 0 auto;
  }

  .languages-overlay {
    width: 80%;
  }

  .language {
    font-size: 24px;
  }
}
</style> 